import React, { useContext, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';

import { CycleCountApi } from 'api/cycleCount';
import { UserContext } from 'contexts/UserContext';
import { FormComponent } from 'shared';

const cycleCountApi = new CycleCountApi();

function SkuCycleCountForm({ closeModal, onSuccess, open }) {
    const [options, setOptions] = useState([]);
    const [packagingOptions, setPackagingOptions] = useState([]);
    const [error, setError] = useState('');
    const user = useContext(UserContext);

    const createSkuCycleCountRequest = async (formData) => {
        if (!formData.skus.length && !formData.packagingIds.length) {
            setError('Please select at least one sku or packaging id');
            return;
        }

        const externalSkus = formData.skus.map((item) => item.value);
        const packagingIds = formData.packagingIds.map((item) => item.value);
        const res = await cycleCountApi.createSkuCycleCountRequest(externalSkus, packagingIds, user.getFacilityID());
        if (!res.status) {
            setError(res.msg);
            return;
        }

        onSuccess();
    };

    useEffect(() => {
        const getOptions = async () => {
            const res = await cycleCountApi.getSkuOptions(user.getFacilityID());
            if (!res.status) {
                setError('Failed to get items');
                return;
            }

            setOptions(res.data.items);
            setPackagingOptions(res.data.packagingItems);
        };

        getOptions();
    }, []);

    const formFields = [
        {
            name: 'skus',
            label: 'Finished Goods Skus',
            inputElement: 'autocomplete',
            inputProps: {
                multiple: true,
                opts: options.map((item) => ({
                    value: item.externalSku,
                    text: `Sku ${item.externalSku} - ${item.name}`,
                })),
            },
        },
        {
            name: 'packagingIds',
            label: 'Packaging Skus',
            inputElement: 'autocomplete',
            inputProps: {
                multiple: true,
                opts: packagingOptions.map((item) => ({
                    value: item.packagingId,
                    text: `Sku ${item.packagingId} - ${item.name}`,
                })),
            },
        },
    ];

    return (
        <Dialog open={open} maxWidth="lg" fullWidth onClose={closeModal}>
            <DialogTitle>Create New Sku Cycle Count</DialogTitle>
            <DialogContent>
                <FormComponent formFields={formFields} onSubmit={createSkuCycleCountRequest} />
                {error && <div style={{ color: 'red' }}>{error}</div>}
            </DialogContent>
        </Dialog>
    );
}

export { SkuCycleCountForm };
